const prefix = 'DhlGuidedTour'

const generateClassName = (slot: string): string => `${prefix}-${slot}`

export const guidedTourClasses: Record<string, string> = {
  root: generateClassName('root'),
  tour: generateClassName('tour'),
  step: generateClassName('step'),
  focus: generateClassName('focus'),
  backdrop: generateClassName('backdrop'),
  arrow: generateClassName('arrow'),
  progress: generateClassName('progress'),
  closeButton: generateClassName('closeButton'),
  backButton: generateClassName('backButton'),
  nextButton: generateClassName('nextButton'),
  finishButton: generateClassName('finishButton'),
  title: generateClassName('title'),
  body: generateClassName('body'),
}
